export const SELLER_CONTACT_LOAD_ATTEMPT = "SELLER_CONTACT_LOAD_ATTEMPT";
export const SELLER_CONTACT_LOAD_SUCCESS = "SELLER_CONTACT_LOAD_SUCCESS";
export const SELLER_CONTACT_LOAD_FAILED = "SELLER_CONTACT_LOAD_FAILED";
///////////////////////////
export const SELLER_CONTACT_SAVE_ATTEMPT = "SELLER_CONTACT_SAVE_ATTEMPT";
export const SELLER_CONTACT_SAVE_SUCCESS = "SELLER_CONTACT_SAVE_SUCCESS";
export const SELLER_CONTACT_SAVE_FAILED = "SELLER_CONTACT_SAVE_FAILED";
